import React from "react";
import {IUserService, UserService} from "../services/userService";
import {
  ITransportServices,
  TransportServices
} from "../services/transportServices";
import {DomainStore, IDomainStore} from "./domainStore/domainStore";
import {IUiStore, UiStore} from "./uiStore/uiStore";

export interface IRootStore {
  transportServices: ITransportServices;
  userService: IUserService;
  uiStore: IUiStore;
  domainStore: IDomainStore;
}

export class RootStore implements IRootStore {
  transportServices: ITransportServices;
  userService: IUserService;
  uiStore: IUiStore;
  domainStore: IDomainStore;

  constructor() {
    // The order of these is important, domain can depend on transport, ui can depend on domain.
    // Never make a dependency in the other direction
    this.transportServices = new TransportServices();
    this.userService = new UserService();
    this.domainStore = new DomainStore(this);
    this.uiStore = new UiStore(this);
  }
}

export const rootStore = new RootStore();

export const StateContext = React.createContext(rootStore as IRootStore);
